import axios from '../axios'

export const selectByPage = (data) => {
    return axios({
        url: '/admin/syncRecord/selectByPage',
        method: 'post',
        data
    })
}

export const taobaoImport = (data) => {
    return axios({
        url: '/admin/syncRecord/taobaoImport',
        method: 'post',
        data
    })
}

export const batchOpen = (data) => {
    return axios({
        url: '/admin/syncTime/batchOpen',
        method: 'post',
        data
    })
}

export const batchClose = (data) => {
    return axios({
        url: '/admin/syncTime/batchClose',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/http/moudules/syncRecord.js